import httpClient from "../httpClient";
import { API_OTP_VERIFICATION } from "../config";

const otpVerificationService = {
  verify: (data) => httpClient.post(API_OTP_VERIFICATION, data),
};

export default otpVerificationService;
